import { buildCidDateKey } from '@pressreader/content-utils';

export function buildCidDateLanguageKey(cidDateKey: string, languageCode?: string): string;
export function buildCidDateLanguageKey(params: { cid: string; issueDate?: Date; languageCode?: string }): string;
export function buildCidDateLanguageKey(...args: unknown[]) {
    if (typeof args[0] === 'string') {
        return args[1] ? `${args[0]}-${args[1]}` : args[0];
    }
    if (args.length === 1 && typeof args[0] === 'object') {
        const { cid, issueDate, languageCode } = args[0] as { cid: string; issueDate?: Date; languageCode?: string };
        const cidDateKey = buildCidDateKey(cid, issueDate);
        return languageCode ? `${cidDateKey}-${languageCode}` : cidDateKey;
    }
    throw new Error('Invalid arguments.');
}

/**
 * Tells whether `key` is a language key of the issue whose language-free key is `cidDateKey`: a key
 * `buildCidDateLanguageKey` built for it with a language. Keys pair the cidDate key with a language
 * after a `-`, and `buildCidDateKey` puts no `-` of its own into the date or the `latest` marker, so
 * the prefix names exactly the language variants of the one issue.
 */
export function isLanguageKeyOfCidDate(key: string, cidDateKey: string): boolean {
    return key.startsWith(`${cidDateKey}-`);
}
